import LogPageAnalyzeReducer from 'store/log/page-analyze/reducers';

export default LogPageAnalyzeReducer;
